import { Component } from '@angular/core'

@Component({
  selector: 'my-empty',
  template: '',
  standalone: true
})
export class EmptyComponent {

}
